import {
    useVrboDisablePropertyMutation,
    useVrboEnablePropertyMutation,
} from "../../../services/bClientApi";
import useVrboAction from "../useVrboAction";
import VrboActionRow from "../VrboActionRow";

export default function VrboVisibilitySection(props: { propertyId: string }) {
    const { propertyId } = props

    const [enableProperty] = useVrboEnablePropertyMutation()
    const [disableProperty] = useVrboDisablePropertyMutation()

    const enabled = !!propertyId

    const enableAction = useVrboAction(
        () => enableProperty(propertyId).unwrap(),
        { errorLabel: 'enabling VRBO property', enabled },
    )
    const disableAction = useVrboAction(
        () => disableProperty(propertyId).unwrap(),
        { errorLabel: 'disabling VRBO property', enabled },
    )

    return (
        <div>
            <VrboActionRow
                action={enableAction}
                variant="success"
                label="Enable Property"
                busyLabel="Enabling..."
                resultTitle="Enable Property Response"
                confirm={{
                    title: 'Enable property?',
                    message: 'This will enable this property on VRBO.',
                }}
            />
            <VrboActionRow
                action={disableAction}
                variant="warning"
                label="Disable Property"
                busyLabel="Disabling..."
                resultTitle="Disable Property Response"
                confirm={{
                    title: 'Disable property?',
                    message: 'This will disable this property on VRBO.',
                }}
            />
        </div>
    )
}
